import React, {createContext} from "react";

const RiskManagementContext = createContext(null)

export default RiskManagementContext;